export const GOOG_ANA = 'UA-104097928-1';
export const RECAPTCHA = '6LcDi7cZAAAAAEJFacFPaizhPJ--tYBreXGk_gYp';